import { t } from "i18next";
import React, { FC, useEffect } from "react";
import { enqueueSnackbar } from "notistack";

import { CardTable } from "@components/common";
import { useCreateProcurementSuppliersAudit } from "@api";
import { useUserStore } from "@store/user";

interface BuyerHubReports {
  columns: CardTable["columns"];
  rows: CardTable["rows"];
  isLoaded: boolean;
}

const BuyerHubReports: FC<BuyerHubReports> = ({ columns, rows, isLoaded }) => {
  const { user } = useUserStore();
  const {
    createProcurementSuppliersAudit,
    createProcurementSuppliersAuditEnabled,
    isPendingCreateProcurementSuppliersAudit,
    isSuccessCreateProcurementSuppliersAudit,
    isErrorCreateProcurementSuppliersAudit,
  } = useCreateProcurementSuppliersAudit(user);

  useEffect(() => {
    if (isSuccessCreateProcurementSuppliersAudit) {
      enqueueSnackbar(t("csob.buyer.hub.auditIsCreated"), { variant: "success" });
    } else if (isErrorCreateProcurementSuppliersAudit) {
      enqueueSnackbar(t("csob.buyer.hub.generateAuditFailed"), { variant: "error" });
    }
  }, [
    isSuccessCreateProcurementSuppliersAudit,
    isErrorCreateProcurementSuppliersAudit,
  ]);

  return (
    createProcurementSuppliersAuditEnabled && (
      <CardTable
        button={{
          variant: "outlined",
          loading: isPendingCreateProcurementSuppliersAudit,
          text: t("csob.buyer.hub.generateAuditFile"),
          onClick: (): void => {
            createProcurementSuppliersAudit();
          },
        }}
        title={t("csob.buyer.hub.reports")}
        type="buyers-reports"
        columns={columns}
        rows={rows}
        isLoaded={isLoaded}
        placeholderText={t("csob.buyer.hub.reportsNotAvailable")}
      />
    )
  );
};

export default BuyerHubReports;
